import { render, staticRenderFns } from "./agreement-selector-modal.vue?vue&type=template&id=12b81c90&scoped=true"
import script from "./agreement-selector-modal.vue?vue&type=script&lang=js"
export * from "./agreement-selector-modal.vue?vue&type=script&lang=js"
import style0 from "./agreement-selector-modal.vue?vue&type=style&index=0&id=12b81c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b81c90",
  null
  
)

export default component.exports